// extracted by mini-css-extract-plugin
module.exports = {"intro":"styles_intro__cEKiW","section":"styles_section__ISAUK","title":"styles_title__eMcfA","cardRight":"styles_cardRight__41RvG","subtitle":"styles_subtitle__zy9Xe"};